module.exports = __webpack_public_path__ + "static/media/jenny.24b1ae36.jpg";